import {useCookies} from "react-cookie";

export const useTokenAuth = () => {
    const [cookies, setCookie] = useCookies(['tour'])
    const queryParameters = new URLSearchParams(window.location.search)
    let token= queryParameters.get("token");

    if (token) {
        setCookie('x-mayair-tour-token', token);
    }
}